import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useDispatch, useSelector} from "react-redux";
import {
    clearBookCard,
    selectorOrder,
    setBookCard,
} from "../../../features/QueuePaymenrt/slices/OrderSlice";

export const useBookCard = (bookId: string, disabled?: Boolean) => {

    const [card, setCard] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const { bookCardT } = useSelector(selectorOrder)

    useEffect(() => {

        if (card || !bookId || disabled) return;

        API.request()
            .get()
            .endpoint(Endpoints.cardsMnePw)
            .url(`api/BookCard/GetBookCard`)
            .addQuery("bookId", bookId || "")
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setCard(r);
                setIsLoading(false)
            })
            .catch((err) => {
                setError(err)
                setIsLoading(false)
            });
    }, [bookId, card, bookCardT, disabled])

    useEffect(() => {
        if (!card) return;
        dispatch(setBookCard({
            bookCard: card
        }))

        return () => {
            dispatch(clearBookCard())
        }
    }, [card])

    return {
        cardId: card?.cardId || null,
        isLoading,
        error
    }
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useDispatch, useSelector} from "react-redux";
import {
    clearBookCard,
    selectorOrder,
    setBookCard,
} from "../../../features/QueuePaymenrt/slices/OrderSlice";

export const useBookCard = (bookId: string, disabled?: Boolean) => {

    const [card, setCard] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const { bookCardT } = useSelector(selectorOrder)

    useEffect(() => {

        if (card || !bookId || disabled) return;

        API.request()
            .get()
            .endpoint(Endpoints.cardsMnePw)
            .url(`api/BookCard/GetBookCard`)
            .addQuery("bookId", bookId || "")
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setCard(r);
                setIsLoading(false)
            })
            .catch((err) => {
                setError(err)
                setIsLoading(false)
            });
    }, [bookId, card, bookCardT, disabled])

    useEffect(() => {
        if (!card) return;
        dispatch(setBookCard({
            bookCard: card
        }))

        return () => {
            dispatch(clearBookCard())
        }
    }, [card])

    return {
        cardId: card?.cardId || null,
        isLoading,
        error
    }
}